import React                         from 'react';
import { MultiSelect}                from '../../lib/iprs-react-library/src/index.js';

/**
 * React component to display a selectable list of Appointment types. This is 
 * similar to the list displayed in the sidebar but with select buttons.
 * 
 * @returns {undefined}
 */
const AppTypeSelector = ({appointmentTypes, selectedAppTypes, setSelectedAppTypes, name='appointmentTypeSelector'}) => {

    return <MultiSelect selectableItems={appointmentTypes} 
                        selectedItems={selectedAppTypes}
                        setSelectedItems={setSelectedAppTypes}
                        getItemID={appType=>appType.AppointmentTypeID}
                        defaultItemID={0}
                        name={name} />
}

export default AppTypeSelector